export const localStorageKey = '__TODO_APP_Store__'